// Review Slider Class
class ReviewSlider {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.sliderTrack = document.getElementById(`sliderTrack-${sectionId}`);
    this.sliderDots = document.getElementById(`sliderDots-${sectionId}`);
    this.prevBtn = document.querySelector(`#${sectionId} .prev-btn`);
    this.nextBtn = document.querySelector(`#${sectionId} .next-btn`);
    this.section = document.getElementById(sectionId);
    
    if (!this.sliderTrack) return;
    
    this.currentSlide = 0;
    this.totalSlides = this.sliderTrack.querySelectorAll('.review-card').length;
    this.slidesPerView = this.getSlidesPerView();
    this.autoRotate = this.section.dataset.autoRotate !== 'false';
    this.autoRotateSpeed = parseInt(this.section.dataset.autoRotateSpeed) * 1000 || 5000;
    this.autoSlideInterval = null;
    
    this.init();
  }
  
  getSlidesPerView() {
    return window.innerWidth < 768 ? 1 : 3;
  }
  
  init() {
    this.updateSlidesPerView();
    this.createDots();
    this.goToSlide(0);
    this.setupEventListeners();
    
    if (this.autoRotate && this.totalSlides > this.slidesPerView) {
      this.startAutoSlide();
    }
    
    // Reinitialize on resize
    window.addEventListener('resize', () => {
      const oldSlidesPerView = this.slidesPerView;
      this.slidesPerView = this.getSlidesPerView();
      
      if (oldSlidesPerView !== this.slidesPerView) {
        this.updateSlidesPerView();
        this.createDots();
        this.goToSlide(Math.floor(this.currentSlide / oldSlidesPerView) * this.slidesPerView);
      }
    });
  }
  
  updateSlidesPerView() {
    const slideWidth = 100 / this.slidesPerView;
    this.sliderTrack.querySelectorAll('.review-card').forEach(card => {
      card.style.flex = `0 0 ${slideWidth}%`;
    });
  }
  
  createDots() {
    if (!this.sliderDots || this.totalSlides <= this.slidesPerView) return;
    
    this.sliderDots.innerHTML = '';
    const totalDots = Math.ceil(this.totalSlides / this.slidesPerView);
    
    for (let i = 0; i < totalDots; i++) {
      const dot = document.createElement('div');
      dot.classList.add('slide-dot');
      dot.addEventListener('click', () => {
        this.goToSlide(i * this.slidesPerView);
      });
      this.sliderDots.appendChild(dot);
    }
    
    this.updateDots();
  }
  
  updateDots() {
    if (!this.sliderDots || this.totalSlides <= this.slidesPerView) return;
    
    const dots = this.sliderDots.querySelectorAll('.slide-dot');
    const activeDotIndex = Math.floor(this.currentSlide / this.slidesPerView);
    
    dots.forEach((dot, index) => {
      if (index === activeDotIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }
  
  goToSlide(slideIndex) {
    // Ensure slide index is within bounds
    if (slideIndex < 0) {
      slideIndex = this.totalSlides - this.slidesPerView;
    } else if (slideIndex >= this.totalSlides) {
      slideIndex = 0;
    } else if (slideIndex > this.totalSlides - this.slidesPerView) {
      slideIndex = this.totalSlides - this.slidesPerView;
    }
    
    this.currentSlide = slideIndex;
    const translateX = -(this.currentSlide * (100 / this.slidesPerView));
    this.sliderTrack.style.transform = `translateX(${translateX}%)`;
    
    this.updateDots();
    
    // Reset auto slide timer
    if (this.autoRotate) {
      this.resetAutoSlide();
    }
  }
  
  nextSlide() {
    let nextSlide = this.currentSlide + this.slidesPerView;
    
    // If at the end, loop back to beginning
    if (nextSlide >= this.totalSlides) {
      nextSlide = 0;
    }
    
    this.goToSlide(nextSlide);
  }
  
  prevSlide() {
    let prevSlide = this.currentSlide - this.slidesPerView;
    
    // If at the beginning, loop to end
    if (prevSlide < 0) {
      prevSlide = this.totalSlides - this.slidesPerView;
    }
    
    this.goToSlide(prevSlide);
  }
  
  setupEventListeners() {
    // Button events
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prevSlide());
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.nextSlide());
    }
    
    // Touch swipe for mobile
    let startX = 0;
    let endX = 0;
    
    this.sliderTrack.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    
    this.sliderTrack.addEventListener('touchend', (e) => {
      endX = e.changedTouches[0].clientX;
      this.handleSwipe(startX, endX);
    }, { passive: true });
    
    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (this.section.contains(document.activeElement) || 
          document.activeElement === document.body) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.prevSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      }
    });
    
    // Pause auto-slide on hover
    this.sliderTrack.addEventListener('mouseenter', () => {
      this.stopAutoSlide();
    });
    
    this.sliderTrack.addEventListener('mouseleave', () => {
      if (this.autoRotate) {
        this.startAutoSlide();
      }
    });
    
    // Pause auto-slide when tab is not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoSlide();
      } else if (this.autoRotate) {
        this.startAutoSlide();
      }
    });
  }
  
  handleSwipe(startX, endX) {
    const swipeThreshold = 50;
    
    if (startX - endX > swipeThreshold) {
      // Swipe left - next slide
      this.nextSlide();
    } else if (endX - startX > swipeThreshold) {
      // Swipe right - previous slide
      this.prevSlide();
    }
  }
  
  startAutoSlide() {
    if (this.totalSlides <= this.slidesPerView) return;
    
    this.stopAutoSlide();
    this.autoSlideInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoRotateSpeed);
  }
  
  stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }
  
  resetAutoSlide() {
    if (this.autoRotate) {
      this.stopAutoSlide();
      this.startAutoSlide();
    }
  }
}

// Initialize all sliders on the page
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-section-type="review-slider"]').forEach(section => {
    new ReviewSlider(section.id);
  });
});

// Handle Shopify section loading
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('[data-section-type="review-slider"]');
    if (section) {
      new ReviewSlider(section.id);
    }
  });
}